import { SlateDescendant } from "@wangeditor/editor";
import { isEmpty } from "lodash-es";

export const nodeToText = (nodes: SlateDescendant[], { prefix = "\\$\\{", suffix = "\\}" }) => {
  let str = "";
  nodes.forEach((node: any, index) => {
    if (node.type === "paragraph") {
      str = str + (str || index !== 0 ? "\n" : "") + nodeToText(node.children, { prefix, suffix });
    } else if (node.type === "variable") {
      str = str + `\${${node.value}}`;
    } else {
      str = str + node.text;
    }
  });
  return str;
};

function generateHtmlFromString(
  input: string,
  data: Record<string, { label: string; value: string }>,
  { prefix = "\\$\\{", suffix = "\\}" }
): string {
  const nodes: string[] = [];
  const words = Object.keys(data).join("|");
  const reg = new RegExp(`(${prefix}[${words}]+${suffix})`, "g");
  const parts = input.split(reg);
  parts.forEach((part) => {
    if (part.match(reg)) {
      const value = part.substring(2, part.length - 1);
      const label = data[value]?.label || value;
      if (label)
        nodes.push(
          `<span data-w-e-type="variable" data-w-e-is-void data-w-e-is-inline data-value="${value}" data-label="${label}">${label}</span>`
        );
    } else {
      nodes.push(part);
    }
  });
  return nodes.join("");
}

export function textToHtml(
  str: string,
  data: Record<string, { label: string; value: string }>,
  { prefix = "\\$\\{", suffix = "\\}" }
) {
  if (!str || isEmpty(data)) return "<p><br></p>";
  const arr = str.split(/\n/);
  const nodes: any[] = [];
  arr.forEach((item) => {
    if (item) {
      nodes.push(`<p>${generateHtmlFromString(item, data, { prefix, suffix })}</p>`);
    } else {
      nodes.push(`<p><br/></p>`);
    }
  });
  return nodes.join("");
}

function generateNodeFromString(
  input: string,
  { prefix = "\\$\\{", suffix = "\\}" },
  data: Record<string, { label: string; value: string }>
) {
  const nodes: any[] = [];
  const words = Object.keys(data).join("|");
  const reg = new RegExp(`(${prefix}[${words}]+${suffix})`, "g");
  const parts = input.split(reg);
  parts.forEach((part) => {
    if (part.match(reg)) {
      const value = part.substring(2, part.length - 1);
      const label = data[value]?.label || value;
      if (value) {
        nodes.push({
          type: "variable",
          value,
          label,
          children: [{ text: "" }]
        });
      }
    } else {
      nodes.push({ text: part });
    }
  });
  return nodes;
}

export function textToNode(
  { prefix = "\\$\\{", suffix = "\\}" },
  str?: string,
  data?: Record<string, { label: string; value: string }>
) {
  if (!str || isEmpty(data)) return "";
  const arr = str.split(/\n/);
  const nodes: any[] = [];
  if (str.indexOf("\n") === -1) {
    return generateNodeFromString(str, { prefix, suffix }, data);
  }
  arr.forEach((item) => {
    if (item) {
      nodes.push({
        type: "paragraph",
        children: generateNodeFromString(item, { prefix, suffix }, data)
      });
    }
  });
  return nodes;
}
